import React from 'react'

export const ShareIcon = ({ stroke = '#374957' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.42857 9H6.28571C5.67951 9 5.09812 9.21071 4.66947 9.58579C4.24082 9.96086 4 10.4696 4 11V19C4 19.5304 4.24082 20.0391 4.66947 20.4142C5.09812 20.7893 5.67951 21 6.28571 21H17.7143C18.3205 21 18.9019 20.7893 19.3305 20.4142C19.7592 20.0391 20 19.5304 20 19V11C20 10.4696 19.7592 9.96086 19.3305 9.58579C18.9019 9.21071 18.3205 9 17.7143 9H16.5714M12 13.5V3M12 3L8.57143 6M12 3L15.4286 6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
